import { deepPurple } from '@mui/material/colors';
import { Box, Stack, Button, Typography } from '@mui/material';

import { useResponsive } from 'src/hooks/use-responsive';

import { BRAND_COLOR } from 'src/theme/core';

interface Props {
  setOpenDemoForm: (value: boolean) => void;
}
export const IntroTeacherManage = ({ setOpenDemoForm }: Props) => {
  const deepPurpleColor = deepPurple.A200;
  const mdDown = useResponsive('down', 'md');

  return (
    <Stack
      direction={mdDown ? 'column' : 'row'}
      alignItems="center"
      minHeight={470}
      py={5}
      spacing={8}
      justifyContent="space-between"
    >
      <Stack alignItems="start" alignSelf="start" flex={mdDown ? 1 : 0.45} height="100%">
        <Typography
          fontFamily='"Shantell Sans Light", sans-serif'
          sx={{ color: deepPurpleColor, mb: 1 }}
          fontSize={18}
          fontWeight="medium"
        >
          Phần mềm quản lý trung tâm thế hệ mới
        </Typography>
        <Typography variant="h2" sx={{ mb: 2.5 }} maxWidth={460}>
          Quản lý giáo viên với CenterUp
        </Typography>
        <Typography variant="h6" mb={2.5} fontWeight="medium" maxWidth={480}>
          Phân công giảng dạy - Lịch dạy trực quan - Chuyên cần & Nghỉ phép - Đánh giá dựa trên tiến
          độ giảng dạy và kết quả điểm số - Giao việc và đánh giá hiệu suất của từng giáo viên.
        </Typography>
        <Typography variant="h6" mb={5}>
          “Tất cả trong một nền tảng duy nhất”
        </Typography>
        <Stack direction="row" alignItems="center" spacing={0.8}>
          <Button
            size="large"
            onClick={() => setOpenDemoForm(true)}
            sx={{
              background: BRAND_COLOR,
              color: 'white',
              '&:hover': {
                background: BRAND_COLOR,
                opacity: 0.9,
              },
              minWidth: 124,
            }}
          >
            Đăng ký Demo
          </Button>
          <Typography variant="subtitle1" sx={{ maxWidth: 256 }} fontWeight={400}>
            Để trải nghiệm quản lý giáo viên kiểu mới với CenterUp
          </Typography>
        </Stack>
      </Stack>
      <Stack position="relative" flex={0.55}>
        <Box
          component="img"
          alt="gradientbg1"
          src="/assets/sub-pages/bg-gradient.png"
          position="absolute"
          zIndex={1}
          left={-200}
          top={-50}
          width="100%"
          height="100%"
        />
        <Box
          component="img"
          alt="gradientbg2"
          src="/assets/sub-pages/bg-gradient1.png"
          position="absolute"
          zIndex={1}
          top={-40}
          sx={{
            right: { xs: 0, md: -120 },
            width: { xs: '130%', md: '100%' },
            height: { xs: '130%', md: '100%' },
          }}
        />

        <Box
          alignSelf={mdDown ? 'center' : 'end'}
          component="img"
          alt="list-class"
          src="/assets/sub-pages/lms/teacher-management/intro.png"
          zIndex={2}
          right={0}
          top={120}
        />
      </Stack>
    </Stack>
  );
};
